<template>
  <span>
    <template v-for="(part, index) in parts" :key="index">
      <span v-if="part.highlighted" class="text-primary1">{{ part.text }}</span>
      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>

<script setup>
import { computed, defineProps } from 'vue'

/**
 * Выделяет цветом куски текста, отмеченные звёздочками:
 * «From *Idea* Into Excellent *Result!*».
 *
 * Разметка собирается тегами, а не строкой с HTML: текст приходит из
 * админки, и вставлять его через v-html нельзя.
 */
const props = defineProps({
  text: { type: String, default: '' },
})

const parts = computed(() => {
  const source = String(props.text ?? '')

  return source
    .split(/(\*[^*]+\*)/g)
    .filter((chunk) => chunk !== '')
    .map((chunk) => chunk.startsWith('*') && chunk.endsWith('*')
      ? { text: chunk.slice(1, -1), highlighted: true }
      : { text: chunk, highlighted: false })
})
</script>
